const settings: ClientSettings = {
  name: "Digitus",
  benefitCardName: "",
  theme: {
    token: {
      colorPrimary: "#274359",
      colorHighlight: "#007C99",
    },
  },
  assets: {
    background: "/bg-digitus.png",
    logo: "/logo-digitus.png",
    favicon: "/favicon-digitus.png",
    card: "",
    consignedCard: "",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#274359",
        colorHighlight: "#007C99",
      },
    },
    assets: {
      background: "",
      logo: "",
      favicon: "",
    },
  },
};

export default settings;
